import axios from 'axios'

// We create our own axios instance and set a custom base URL.
// Note that if we wouldn't set any config here we do not need
// a named export, as we could just `import axios from 'axios'`

const Axios = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    transformRequest: [function (data, headers) {
        // Add token to every query
        let token = localStorage.getItem('token') || null
        headers.Authorization = `Bearer ${token}`

        return JSON.stringify(data)
    }],
    transformResponse: [(d) => {
        let data = JSON.parse(d)
        if (data.status_code === 401) {
            localStorage.removeItem('token')
            localStorage.removeItem('user.id')
            localStorage.removeItem('user.role')
            localStorage.removeItem('accounts')
            localStorage.removeItem('didModalInstallationAppeared')
            window.open(process.env.VUE_APP_ORANGE_PRO_APP,'_self')
        }
        return data
    }]
})

// Here we define a named export
// that we can later use inside .js files:

export {
    Axios
}
